module.exports = __webpack_public_path__ + "static/img/logo.61d6c78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wrap-img/logo.svg
// module id = O67S
// module chunks = 1